import { METRICS_TYPE } from 'globalUtils/constants'

const METRICS_LABELS = [
  {
    label: 'Page Loads',
    value: METRICS_TYPE.LOAD,
  },
  {
    label: 'Students',
    value: METRICS_TYPE.STUDENT,
  },
  {
    label: 'Demo Access',
    value: METRICS_TYPE.DEMO,
  },
]

export default METRICS_LABELS



// WEBPACK FOOTER //
// ./client/masteradmin/components/MetricsModal/constants.js